/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IGeneric } from '../../interfaces';

export interface IHtmlHead {
    tags: HtmlHeadElement[];
    nonScriptTags: HtmlHeadElement[];
    scriptTags: {
        headStart: HtmlHeadElement[];
        headEnd: HtmlHeadElement[];
        bodyStart: HtmlHeadElement[];
        bodyEnd: HtmlHeadElement[];
    };
    hasFavIcon: boolean;
}

export interface IHtmlHeadProps {
    children: React.ReactChild[];
}

export type HtmlHeadElement = React.ReactElement<IGeneric<unknown>>;

export const NON_SCRIPT_TAGS = 'non-script-tags';
export const DATA_LOAD_POINT = 'data-load-point';
export const HEAD_START_LOAD_POINT = 'headStart';
export const HEAD_END_LOAD_POINT = 'headEnd';
export const BODY_START_LOAD_POINT = 'bodyStart';
export const BODY_END_LOAD_POINT = 'bodyEnd';
export const HEAD_ELEMENT_IDENTIFIER_ATTR = 'data-ms-head';
export const META_CONTENT_APPEND_ATTR = 'data-append-content';
export const DATA_ACTION_ATTR = 'data-ms-action';
export const METATYPES = ['name', 'httpEquiv', 'charSet', 'itemProp', 'property', 'description', 'keywords'];
export const FAVICON_REL: string[] = ['shortcut icon', 'icon', 'apple-touch-icon-precomposed', 'mask-icon', 'apple-touch-icon'];
export const COMPONENT_TYPES = [NON_SCRIPT_TAGS, HEAD_START_LOAD_POINT, HEAD_END_LOAD_POINT, BODY_START_LOAD_POINT, BODY_END_LOAD_POINT];
export const ALLOWED_DUPLICATES = new Set([
    'article:tag',
    'og:description',
    'og:image',
    'og:image:alt',
    'og:image:width',
    'og:image:height',
    'og:image:type',
    'og:image:secure_url',
    'og:image:url',
    'description'
]);

export const TAG_NAMES = {
    TITLE: 'title',
    BASE: 'base',
    META: 'meta',
    SCRIPT: 'script',
    LINK: 'link'
};
